import React from "react"
import { Box } from "@mui/material"
import { AppCheckMark } from "@components"


export default function checkerColumn(name) {
	return {
		name: name,
		render: value => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<AppCheckMark value={value} label={name}/>
		</Box>
	}
}
